
export enum EnumTipoCamaraFria {
  Resfriados = 'Resfriados',
  Congelados = 'Congelados',
}
